require('../../modules/es6.number.parse-int');
module.exports = require('../../modules/_core').Number.parseInt;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/number/parse-int.js
// module id = 814
// module chunks = 0